<template>
    <div id="commodity">
        <div class="rightNav">
            <ul>
                <li @mouseenter="hover1=true" @mouseleave="hover1=false" @click="goPersonal()">
                    <i class="el-icon-user"></i>
                    <p class="hovers hover1" v-show="hover1">进入个人中心</p>
                </li>
                <li @mouseenter="hover2=true" @mouseleave="hover2=false" @click="goCar()">
                    <i class="fa fa-shopping-cart"></i>
                    <p class="hovers hover2" v-show="hover2">进入购物车</p>
                </li>
                <li @mouseenter="hover3=true" @mouseleave="hover3=false">
                    <i class="fa fa-qrcode"></i>
                    <p class="hovers hover3" v-show="hover3">
                        <img src="@/assets/img/two.png" alt />
                    </p>
                </li>
                <p @click="backTop" class="backTop">
                    <i class="el-icon-upload2"></i>
                </p>
            </ul>
        </div>
        <div class="indexLoginBottomHead">
            <div class="bottom-head">
                <div class="contain">
                    <el-row style="line-height:61px">
                        <el-col :span="8">
                            <div class="head-logo">
                                <img src="@/assets/img/logo7.png" alt />
                            </div>
                        </el-col>
                        <el-col :span="10" class="search">
                            <el-input
                                placeholder="请输入关键词搜索"
                                v-model="seachInput"
                                class="input-with-select head-input"
                                style="width:500px;border:1px solid #f64420"
                            >
                                <template slot="append">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-search"
                                        id="searchButton"
                                        @click="seach('seachTop')"
                                    >搜索</el-button>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="topList">
                <h3 @click="boxshow = !boxshow">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                    <span>商品分类</span>
                    <div class="topList-list" v-show="boxshow" @mouseleave="boxshow=false">
                        <ul>
                            <li
                                v-for="(item,index) in categoryList"
                                :key="index"
                                @click="goProductDetails(item.id,item.atOname)"
                            >
                                <span>{{item.atOname}}</span>
                                <i class="el-icon-arrow-right" aria-hidden="true"></i>
                            </li>
                        </ul>
                    </div>
                </h3>
                <ul class="nav">
                    <li
                        v-for="(item,index) in categoryList5"
                        :key="index"
                        @click="goProductDetails(item.id,item.atOname)"
                    >{{item.atOname}}</li>
                </ul>
            </div>
            <div class="changes">
                <p class="changeL">已选择：</p>
                <div class="changeR">
                    <el-tag
                        closable
                        :disable-transitions="false"
                        @close="handleClose(dynamicTags)"
                        v-if="dynamicTags"
                    >{{dynamicTags}}</el-tag>
                </div>
            </div>
            <div class="condition">
                <div class="conditionL">
                    <span class="btn zh" @click="zhClick()">
                        综合
                        <i class="fa fa-arrow-down" aria-hidden="true"></i>
                    </span>
                    <span class="btn xl" @click="xlClick()">
                        销量
                        <i class="fa fa-arrow-down" aria-hidden="true"></i>
                    </span>
                    <span class="btn jg" @click="jgClick()">
                        价格
                        <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                    <p class="qj">
                        <el-input type="text" placeholder="¥" class="min" v-model="atYhjgStart"></el-input>
                        <span>-</span>
                        <el-input type="text" placeholder="¥" class="max" v-model="atYhjgEnd"></el-input>
                    </p>
                    <el-input
                        type="text"
                        placeholder="在结果中搜索..."
                        class="queryInput"
                        v-model="atSpmc"
                    ></el-input>
                    <span class="query" @click="seach('seachBtm')">搜索</span>
                </div>
                <div class="conditionR">
                    <p>
                        共
                        <span>{{DataList.total}}</span>件相关商品
                    </p>
                </div>
            </div>
            <div class="Product1" v-if="Lists.length>0">
                <div class="ProductList" v-for="(item,index) in Lists" :key="index">
                    <div class="ProductImg" @click="goDetail(item.id)">
                        <img :src="item.atCoverUrl?$store.state.imgUrl+item.atCoverUrl:'@/assets/img/zhanwei.png'" alt />
                    </div>
                    <div class="Product">
                        <div class="ProductW">
                            <p class="p1">
                                <span class="tit" v-if="item.optYpfl=='1'">{{item.pinyinName}}</span>
                                <span class="tit2" v-if="item.optYhlx =='1'">{{item.atZkbl}}折</span>
                                <span class="tg" v-if="item.optYhlx =='2'">团购</span>
                            </p>
                            <p class="p2" @click="goDetail(item.id)">{{item.atSpmc}}</p>
                        </div>
                        <div class="p3">
                            <p class="money">
                                <span v-if="item.optYhlx==3" class="buyPrice">
                                    ￥{{item.atYpdj}}
                                    <!-- <i>/{{item.atBzgg}}</i> -->
                                </span>
                                <span v-if="item.optYhlx==2 || item.optYhlx==1">
                                    <span class="buyPrice">
                                        ￥{{item.atYhjg}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                    <span class="oldPrice">
                                        ￥{{item.atYpdj}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                </span>
                            </p>
                            <p class="rightBox">
                                月销：{{ item.monthSaleCount }}
                            </p>
                            <!-- <p class="car" @click="addCar(item.id)">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="Product3" v-if="!Lists.length >0">
                <div class="quesheng">
                    <img src="@/assets/img/quesheng1.png" alt />
                    <p>未找到符合条件的商品!</p>
                </div>
            </div>
            <div class="page" v-if="Lists.length >0">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="DataList.total"
                    :page-size="pageSize"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
            <h3 class="shopList">
                <span class="shopListL">
                    推荐药品
                </span>
            </h3>
            <div class="Product2">
                <div class="ProductList ProductList2" v-for="(item,index) in MainList" :key="index">
                    <div class="ProductImg" @click="goDetail(item.id)">
                        <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                    </div>
                    <div class="Product height2">
                        <div class="ProductW">
                            <p class="p1">
                                <span class="tit">{{item.pinyinName}}</span>
                                <span class="tit2" v-if="item.atZkbl">{{item.atZkbl}}折</span>
                                <span class="tit2 tit2" v-if="false">{{item.optYhlx}}</span>
                            </p>
                            <p class="p2" @click="goDetail(item.id)">{{item.atSpmc}}</p>
                        </div>
                        <div class="p3">
                              <p class="money">
                                <span v-if="item.optYhlx==3" class="buyPrice">
                                    ￥{{item.atYpdj}}
                                    <!-- <i>/{{item.atBzgg}}</i> -->
                                </span>
                                <span v-if="item.optYhlx==2 || item.optYhlx==1">
                                    <span class="buyPrice">
                                        ￥{{item.atYhjg}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                    <span class="oldPrice" :title="'￥'+item.atYpdj">
                                        ￥{{item.atYpdj}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                </span>
                            </p>
                            <p class="rightBox">
                                月销：{{ item.monthSaleCount }}
                            </p>
                            <!-- <p class="car" @click="addCar(item.id)">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IndexBottom from "@/components/ShoppingMall/IndexBottom";
export default {
    name: "product",
    data() {
        return {
            hover1: false, //个人中心
            hover2: false, //购物车
            hover3: false, //二维码
            id: "",
            userId: "",
            seachFlag: "", //判断搜索是头部搜索还是搜索结果搜索
            seachInput: "", //头部搜索
            boxshow: false, //分类show
            zong: false, //综合
            xiao: false, //销量
            jia: false, //价格
            payNumOrder: "", //顺序
            atYhjgStart: "", //价钱开始
            atYhjgEnd: "", //价钱结束
            atZdFlag: "", //主打商品
            atSpmc: "", //关键词搜索
            pageNum: 1, //页码
            categoryList: [], //商品分类
            categoryList5: [], //商品分类(推荐的五条)
            DataList: {}, //主体数据
            Lists: [], //商品数据
            dynamicTags: "",
            pageSize: 12,
            MainList:[]
        };
    },
    components: {
        IndexBottom: IndexBottom
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }
        if (this.$route.query.select) {
            this.seachInput = this.$route.query.select;
            this.seach("seachTop");
        }
        if (this.$route.params.name) {
            this.dynamicTags = this.$route.params.name;
        }
        if (this.$route.params.id) {
            //分类id
            if (this.$route.params.id == "zhuda") {
                this.id = "";
                this.atZdFlag = "1";
            } else {
                this.id = this.$route.params.id;
            }
        }
        if (this.$route.query.content) {
            this.seach = this.$route.query.content; //头搜索信息
        }
    },
    mounted() {
        this.getType(); //获取分类
        this.getData(); //获取数据
        this.getshopData()// 获取推荐商品
    },
    methods: {
        defaultPhoto(i) {
            return i ? i : "static/img/bj.jpg";
        },
        getshopData () {
            let url = "/spgl/indexByRecommend";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    // console.log(res.data.data);
                    this.MainList = res.data.data
                }
            });
        },
        getType() {
            //分类渲染
            let url = "/spfl/getListBySpgl";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.categoryList = res.data.data;
                    console.log(this.categoryList);
                    for (var i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList.length < 5) {
                            this.categoryList5.push(this.categoryList[i]);
                        } else {
                            if (i < 6) {
                                this.categoryList5.push(this.categoryList[i]);
                            }
                        }
                    }
                }
            });
        },
        getData() {
            //获取数据
            var params = {};
            if (this.seachFlag == "seachTop") {
                params.atSpmc = this.seachInput; //顶部搜索
                this.atSpmc = "";
            } else if (this.seachFlag == "seachBtm") {
                params.atSpmc = this.atSpmc; //条件 搜索
                this.seachInput = "";
            } else {
                params.atSpmc = ""; //关键词搜索
            }
            // if (!this.atZdFlag) {
                //如果不是主打商品
                params.spSpfl = this.id; //分类编号
            // } else {
            //     params.spSpfl = ""; //分类编号
            // }
            //顺序
            if (this.zong) {
                //综合
                params.dateOrder = "down"; //倒序
            } else {
                params.dateOrder = "up"; //正序
            }
            if (this.xiao) {
                //销量
                params.payNumOrder = "down"; //倒序
            } else {
                params.payNumOrder = "up"; //正序
            }
            if (this.jia) {
                //价格
                params.yhjgOrder = "down"; //倒序
            } else {
                params.yhjgOrder = "up"; //正序
            }
            if (this.atYhjgStart) {
                params.atYhjgStart = this.atYhjgStart; //价钱开始
            }
            if (this.atYhjgEnd) {
                params.atYhjgEnd = this.atYhjgEnd; //价钱结束
            }
            if (this.atZdFlag) {
                params.atZdFlag = this.atZdFlag; //主打商品
            }
            params.pageNum = this.pageNum; //页码
            params.pageSize = this.pageSize; //页个数
            let url = "/spgl/getListAppIndex";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    // console.log(res);
                    this.DataList = res.data.data;
                    this.Lists = res.data.data.list;
                    // console.log(this.DataList.list.length,'this.DataList.list.length')
                    for (var j = 0; j < this.DataList.list.length; j++) {
                        if (this.DataList.list[j].atCoverUrl) {
                            this.DataList.list[
                                j
                            ].atCoverUrl = this.DataList.list[
                                j
                            ].atCoverUrl.split(",")[0];
                        }
                    }
                    // console.log(this.DataList.list, "123");
                }
            });
        },
        goDetail(id) {
            //跳转详情
            // console.log(id);
            this.$router.push({ path: "/ProductDetails/" + id });
        },
        handleClose(name) {
            this.dynamicTags = "";
            this.id = "";
            this.atZdFlag=null; 
            this.getData();
        },
        goProductDetails(id, name) {
            this.id = id;
            this.dynamicTags = name;
            this.getData();
        },
        zhClick() {
            //综合
            this.zong = true;
            this.xiao = false; //销量
            this.jia = false; //价格
            this.getData();
        },
        xlClick() {
            //销量
            this.xiao = true; //销量
            this.zong = false; //综合
            this.jia = false; //价格
            this.getData();
        },
        jgClick() {
            //价格
            this.xiao = false; //销量
            this.zong = false; //综合
            this.jia = !this.jia; //价格

            this.getData();
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.getData();
        },
        seach(name) {
            this.seachFlag = name;
            this.getData();
        },
        addCar(id) {
            //轮播图
            let url = "/gwcgl/save";
            var params = {};
            if (this.userId) {
                params.userId = this.userId;
                params.spSpgl = id;
                params.atSpsl = "1";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        console.log(res);
                        this.$message({
                            message: "添加购物车成功！",
                            type: "success"
                        });
                    }
                });
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        goCar() {
            //购物车
            if (this.userId) {
                this.$router.push({ path: "/car" });
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        goPersonal() {
            //个人中心
            if (this.userId) {
                if (sessionStorage.getItem("YS") == "false") {
                    //当前不是医师
                    this.$router.push({ path: "/personalInformation" });
                } else {
                    this.$router.push({ path: "/personalFiles" });
                }
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        backTop() {
            document
                .getElementById("commodity")
                .scrollIntoView({ behavior: "smooth" });
        }
    }
};
</script>
<style scoped>
#commodity {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    margin: 0px auto;
}
.changes {
    width: 100%;
    height: 30px;
    margin-top: 10px;
}
.changeL {
    width: 7%;
    height: 30px;
    line-height: 30px;
    color: #666;
    float: left;
}
.changeR {
    height: 98%;
    width: 93%;
    float: right;
}
.condition {
    width: 100%;
    height: 50px;
    background: #e6e6e6;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 15px;
}
.condition .conditionL {
    float: left;
    width: 75%;
    height: 100%;
}
.conditionL .btn {
    float: left;
    display: block;
    width: 80px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border: 1px solid #ddd;
    background: #fff;
    color: #666;
    margin-right: 15px;
    cursor: pointer;
}
.conditionL .btn:hover {
    border: 1px solid #f64420;
}
.conditionL .qj {
    float: left;
    width: 140px;
    height: 25px;
}
.qj .min,
.qj .max {
    float: left;
    width: 60px;
    height: 25px;
    line-height: 25px;
}
.qj span {
    display: block;
    float: left;
    width: 20px;
    height: 25px;
    line-height: 25px;
    text-align: center;
}
.queryInput {
    float: left;
    display: block;
    width: 190px;
    height: 25px;
    margin-left: 15px;
}
.conditionL .query {
    display: block;
    float: left;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: #f64420;
    margin-left: 10px;
    cursor: pointer;
}
.condition .conditionR {
    float: right;
    width: 25%;
    height: 30px;
    line-height: 30px;
    text-align: right;
}
.conditionR p {
    width: 100%;
    font-size: 14px;
    color: #999;
}
.conditionR p span {
    font-size: 16px;
    font-weight: 600;
    color: #474747;
}
/* 商品列表样式 */
.Product1,
.Product2 {
    width: 100%;
}
.Product1::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.Product2::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.ProductList {
    float: left;
    width: 24%;
    height: 200px;
    margin: 20px 13px 20px 0;
}
.ProductList2 {
    float: left;
    width: 18.7%;
    height: 210px!important;
    margin: 20px 13px 0 0;
}
.ProductList:nth-child(4n + 4) {
    margin-right: 0;
}
.ProductList2:nth-child(4n + 4) {
    margin-right: 13px;
}
.ProductList2:nth-child(5n + 5) {
    margin-right: 0;
}
.ProductList .ProductImg {
    width: 100%;
    height: 137px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}
.ProductImg img {
    width: 100%;
    min-height: 100%;
}
.Product {
    width: 100%;
    height: 70px;
    background: #fff;
    /* margin-top: 10px; */
}
.Product .ProductW {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
}
.Product .ProductW .p1{
    float: right;
    width: 26%;
}
.Product .ProductW .p2{
    font-size: 15px;
    float: left;
    width: 130px;
    height: 25px;
    line-height: 25px;
    white-space: nowrap!important; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
}
.Product .p3 .rightBox{
    font-size: 12px;
    float: right;
    text-align: right;
    margin-right: 10px;
    height: 25px;
    line-height: 27px;
    color: #aaa;
}
.ProductW::after{
    content: "";
    display: block;
    visibility: hidden;
    overflow: hidden;
    clear: both;
}

.Product .p1 {
    width: 100%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.Product .p1 .tit {
    display: block;
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909090;
    margin-left:5px;
}
.Product .p1 .tit2 {
    display: block;
    float: right;
    height: 16px;
    line-height: 16px;
    width: 35px;
    text-align: center;
    border: 1px solid #f74320;
    border-radius: 3px;
    background: #ffece8;
    margin-right: 10px;
    color: #f74320;
    margin-top: 5px;
    padding: 0 3px;
}
.Product .p1 .tit2 .tg {
    background: #e8f6ff;
    color: #56c7fc;
    border: 1px solid #63baf2;
     border-radius: 3px;

}
.Product .p1 .tg {
    display: block;
    float: right;
    height: 16px;
    line-height: 16px;
    width: 35px;
    text-align: center;
    background: #e8f6ff;
    color: #56c7fc;
    border: 1px solid #63baf2;
    margin-right: 10px;
    margin-top: 5px;
    border-radius: 3px;
}

.Product .p1 .tit22 {
    border: 1px solid #64b9f2;
     border-radius: 3px;
    background: #e8f7fe;
    color: #64b9f2;
}
.Product .p2 {
    height: 40px;
    line-height: 20px;
    color: #666;
    margin-top: 5px;
    cursor: pointer;
    margin-left: 5px;
}
.Product .p3 {
    width: 100%;
    height: 25px;
    /* margin-top: 20px; */
}
.Product .p3 .money {
    float: left;
    width: 50%;
    text-indent: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.p3 .money span {
    color: #f74320;
    font-size: 16px;
    font-weight: 600;
}
.p3 .money i {
    color: #999;
    font-size: 16px;
    font-style: normal;
}
.Product .p3 .car {
    float: right;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    margin-right: 10px;
    /* margin-top:5px; */
    background: #f74320;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
}
.p3 .money .oldPrice {
    text-decoration: line-through;
    font-size: 12px;
    color: #999;
}
.money .buyPrice {
    font-size: 18px;
}
.Product3{
  display: flex;
    justify-content: center;
}
.quesheng{
  text-align: center;
  margin-top: 60px;
}
</style>

<style>
#commodity .el-input__inner {
    height: 30px !important;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.el-tag {
    background-color: transparent;
    border-color: #f64420;
    display: inline-block;
    height: 25px;
    padding: 0 10px;
    line-height: 25px;
    font-size: 12px;
    color: #f64420;
    border-width: 1px;
    border-style: dashed;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
}
.el-tag .el-tag__close {
    color: #f64420;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.shopList {
    width: 100%;
    height: 64px;
    line-height: 64px;
    font-weight: 500;
    border-bottom: 2px solid #ccc;
    margin-bottom: 0;
}
.shopListL {
    float: left;
    width: 140px;
    font-size: 24px;
    color: #333;
}

</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/commodity.vue